var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSearchV1 = function SvgSearchV1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.628,
    height: 19.628
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.2,
    stroke: "currentColor",
    fill: "none",
    d: "m14.32998,14.33a7.75,7.75 0 1 1 2.27,-5.48a7.726,7.726 0 0 1 -2.27,5.48l4.52,4.52l-4.52,-4.52z"
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkuNjI4IiBoZWlnaHQ9IjE5LjYyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPHBhdGggc3Ryb2tlLXdpZHRoPSIyLjIiIHN0cm9rZT0iY3VycmVudENvbG9yIiBmaWxsPSJub25lIiBkPSJtMTQuMzI5OTgsMTQuMzNhNy43NSw3Ljc1IDAgMSAxIDIuMjcsLTUuNDhhNy43MjYsNy43MjYgMCAwIDEgLTIuMjcsNS40OGw0LjUyLDQuNTJsLTQuNTIsLTQuNTJ6Ii8+DQo8L3N2Zz4NCg==";
export { SvgSearchV1 as ReactComponent };